import { find } from 'lodash';

export const formatStatus = (status, approved, progressed) => {
  const statusList = [
    {
      value: 1,
      label: 'Pending',
      variant: 'base3',
      icon: 'in-progress'
    },
    {
      value: 2,
      label: 'Approved',
      variant: 'success',
      icon: 'success'
    },
    {
      value: 3,
      label: 'Declined',
      variant: 'failure',
      icon: 'declined'
    },
    {
      value: 4,
      variant: 'base3',
      label: 'Submitted',
      icon: 'submitted'
    }
  ];

  // if approved return progressed as normal
  if (progressed) {
    if (approved.Id === 2) {
      return progressed
        ? { label: 'Progressed', variant: 'success', icon: 'success' }
        : { label: 'Approved', variant: 'success', icon: 'success' };
    }
  }

  return find(statusList, {
    value: status.Id
  });
};

export const sortHistoryDescending = details => {
  const workflowDetailsSorted = details.sort(
    (a, b) =>
      a.ActionedDate < b.ActionedDate
        ? 1
        : a.ActionedDate > b.ActionedDate ? -1 : 0
  );
  return workflowDetailsSorted;
};



// WEBPACK FOOTER //
// ./src/features/corporate-quote/workflow/helper.js